const translationsLocations = {
  'de-DE': {
    openingHours: 'Öffnungszeiten',
    nextAppointment: 'Nächster freier Termin',
    openGoogleMaps: 'In Google Maps anzeigen',
    daysOfTheWeek: {
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
      saturday: 'Samstag',
    },
  },
  'de-AT': {
    openingHours: 'Öffnungszeiten',
    nextAppointment: 'Nächster freier Termin',
    openGoogleMaps: 'In Google Maps anzeigen',
    daysOfTheWeek: {
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
      saturday: 'Samstag',
    },
  },
  'de-CH': {
    openingHours: 'Öffnungszeiten',
    nextAppointment: 'Nächster freier Termin',
    openGoogleMaps: 'In Google Maps anzeigen',
    daysOfTheWeek: {
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
      saturday: 'Samstag',
    },
  },
  'pt-PT': {
    openingHours: 'Horário de funcionamento',
    nextAppointment: 'Próximo agendamento disponível',
    openGoogleMaps: 'Explorar no Google Maps',
    daysOfTheWeek: {
      monday: 'Segunda-feira',
      tuesday: 'Terça-feira',
      wednesday: 'Quarta-feira',
      thursday: 'Quinta-feira',
      friday: 'Sexta-feira',
      saturday: 'Sábado',
    },
  },
  'en-GB': {
    openingHours: 'Opening hours',
    nextAppointment: 'Next available appointment:',
    openGoogleMaps: 'Show in Google Maps',
    daysOfTheWeek: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
    },
  },
  es: {
    openingHours: 'Horarios de apertura',
    nextAppointment: 'Próxima cita disponible',
    openGoogleMaps: 'Explorar en Google Maps',
    daysOfTheWeek: {
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábado',
    },
  },
  fr: {
    openingHours: "Horaires d'ouverture",
    nextAppointment: 'Prochaine disponibilité :',
    openGoogleMaps: 'Ouvrir dans Google Maps',
    daysOfTheWeek: {
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi',
    },
  },
  pl: {
    openingHours: 'Godziny otwarcia',
    nextAppointment: 'Kolejna dostępna wizyta:',
    openGoogleMaps: 'Pokaż w Google Maps',
    daysOfTheWeek: {
      monday: 'Poniedziałek',
      tuesday: 'Wtorek',
      wednesday: 'Środa',
      thursday: 'Czwartek',
      friday: 'Piątek',
      saturday: 'Sobota',
    },
  },
  it: {
    openingHours: 'Orari',
    nextAppointment: 'Prossima disponibilità',
    openGoogleMaps: 'Apri in Google Maps',
    daysOfTheWeek: {
      monday: 'Lunedì',
      tuesday: 'Martedì',
      wednesday: 'Mercoledì',
      thursday: 'Giovedì',
      friday: 'Venerdì',
      saturday: 'Sabato',
    },
  },
  se: {
    openingHours: 'Öppningstider',
    nextAppointment: 'Nästa lediga tid',
    openGoogleMaps: 'Visa på Google Maps',
    daysOfTheWeek: {
      monday: 'Måndag',
      tuesday: 'Tisdag',
      wednesday: 'Onsdag',
      thursday: 'Torsdag',
      friday: 'Fredag',
      saturday: 'Lördag',
    },
  },
  nl: {
    openingHours: 'Openingstijden',
    nextAppointment: 'Eerst beschikbare afspraak',
    openGoogleMaps: 'Bekijk in Google Maps',
    daysOfTheWeek: {
      monday: 'Maandag',
      tuesday: 'Dinsdag',
      wednesday: 'Woensdag',
      thursday: 'Donderdag',
      friday: 'Vrijdag',
      saturday: 'Zaterdag',
    },
  },
};

module.exports = translationsLocations;
